import "./User.scss";

import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { AppContext } from "../data/AppContextContainer";
import { auth } from "../services/GoogleAuth";

const UserProfile = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const context = useContext(AppContext);

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    auth.signOut().then(() => {
      context.showNotification({
        title: "Logged out"
      });

      navigate("/login");
    });
  };

  const { name, profileImage } = auth.getUserProfile();

  return (
    <div className="User">
      <div className="User__profile">
        <img
          className="User__img"
          src={profileImage}
          alt=""
          onClick={handleToggleMenu}
        />

        {isMenuOpen && (
          <>
            <button className="User__close-menu" onClick={handleToggleMenu} />

            <div className="User__menu">
              <small>
                Logged in as: <br />
                {name}
              </small>

              <button className="User__logout-button " onClick={handleLogout}>
                Logout
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserProfile;
